import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../store/store';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { setActiveStep, updateFormData } from './onboardingSlice';
import StepNav from './StepNav';

const RegisterAuthorize = () => {
  const dispatch: AppDispatch = useDispatch();
  const { formData, activeStep, brandConfig } = useSelector((s: RootState) => s.onboarding);
  const [touched, setTouched] = useState(false);

  const toggle = (key: keyof typeof formData) =>
    dispatch(updateFormData({ [key]: !(formData as any)[key] } as any));

  const handleBack = () => dispatch(setActiveStep(activeStep - 1));

  const defaultRequirements = {
    hasWhatsAppSupportAdded: { enabled: true, text: 'For ongoing support, I have added WhatsApp support +44 7539 270119.', contact_number: '+44 7539 270119' },
    awareDemoMode: { enabled: true, text: 'I am aware the device is in DEMO MODE until switched to LIVE; I will not process real transactions.' },
  };

  const requirementsRaw = brandConfig?.register_authorize_requirements || defaultRequirements;
  const requirements = {
    hasWhatsAppSupportAdded: {
      ...defaultRequirements.hasWhatsAppSupportAdded,
      ...(requirementsRaw as any).hasWhatsAppSupportAdded,
    },
    awareDemoMode: {
      ...defaultRequirements.awareDemoMode,
      ...(requirementsRaw as any).awareDemoMode,
    },
  };

  const enabledRequirements = (Object.entries(requirements) as [keyof typeof requirements, { enabled?: boolean }][])
    .filter(([, config]) => Boolean(config?.enabled))
    .map(([key]) => key);

  const allChecked = enabledRequirements.every((key) => formData[key]);
  const missingLabels: Record<string, string> = {
    hasWhatsAppSupportAdded: 'Confirm WhatsApp support has been added',
    awareDemoMode: 'Confirm you understand DEMO MODE',
  };
  const missing = enabledRequirements
    .filter((key) => !formData[key])
    .map((key) => missingLabels[String(key)] || `Confirm: ${String(key)}`);

  const handleNext = () => {
    setTouched(true);
    if (!allChecked) return;
    dispatch(setActiveStep(activeStep + 1));
  };

  return (
    <>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
        Direct Debit, the Rapyd agreement and merchant conditions continue on the overview after you submit this form.
      </Typography>
      <Box sx={{ display: 'grid', gap: 1.5 }}>
        {requirements.hasWhatsAppSupportAdded.enabled && (
          <FormControlLabel
            control={<Checkbox checked={Boolean(formData.hasWhatsAppSupportAdded)} onChange={() => toggle('hasWhatsAppSupportAdded')} />}
            label={(
              <span>
                For ongoing support, I have added WhatsApp support{' '}
                <strong>{requirements.hasWhatsAppSupportAdded.contact_number}</strong>.
              </span>
            )}
          />
        )}
        {requirements.awareDemoMode.enabled && (
          <FormControlLabel
            control={<Checkbox checked={Boolean(formData.awareDemoMode)} onChange={() => toggle('awareDemoMode')} />}
            label={(
              <span>
                I am aware the device is in <strong>DEMO MODE</strong> until switched to LIVE; I will not process real transactions.
              </span>
            )}
          />
        )}
      </Box>
      <StepNav onBack={handleBack} onNext={handleNext} missing={missing} showMissing={touched} />
    </>
  );
};

export default RegisterAuthorize;
